import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=453341ea&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453341ea')) {
      api.createRecord('453341ea', component.options)
    } else {
      api.reload('453341ea', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=453341ea&", function () {
      api.rerender('453341ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-209pZ5VOBQdYH/JS/comp/ImgFallback.vue"
export default component.exports